import React from 'react';

import { IonIcon } from '@ionic/react';
import { checkmarkOutline, closeOutline, hourglass } from 'ionicons/icons';

import {
  SIGN_STATUS_APPROVED,
  SIGN_STATUS_PENDING,
  SIGN_STATUS_REJECTED,
} from 'scenes/FinancePage/IO/constants';

import { IActionStatus } from './interfaces';

const ActionStatus: React.FC<IActionStatus> = ({ signStatus }) => {
  if (signStatus === SIGN_STATUS_PENDING) {
    return <IonIcon icon={hourglass} color={'medium'} />;
  }

  if (signStatus === SIGN_STATUS_APPROVED) {
    return <IonIcon icon={checkmarkOutline} color={'success'} />;
  }

  if (signStatus === SIGN_STATUS_REJECTED) {
    return <IonIcon icon={closeOutline} color={'danger'} />;
  }

  return null;
};

export default ActionStatus;
